import React from "react";
import { MESSAGE_EMOJI_SRC } from "../../../../constants/components/emoji";
import { CButton } from "../../../UI";

const EmojiButton = ({ emoji, onClick }) => {
    return (
        <CButton
            blank
            onClick={() => onClick(emoji)}
        >
            <div className="emoji-picker-smileys-item-image">
                <img
                    src={MESSAGE_EMOJI_SRC(emoji.codes.join('_'))}
                    alt=""
                />
            </div>
        </CButton>
    );
};

export default EmojiButton;
